/* mapping of models in korba & project
association.relieving.distress => 1
association.beneficiary.service.request => 2
project => 3
general donation => 3
*/

export const korbaProjectModels = [
  {
    name: "association.relieving.distress",
    key: 1,
  },

  {
    name: "association.beneficiary.service.request",
    key: 2,
  },
  {
    name: "project",
    key: 3,
  },
  {
    name: "generalDonation",
    key: 4,
  },
];
